import { setContext } from '@sentry/core';

import { getConfig } from './getConfig.ts';
import { parseMobileApp } from './hooks/useIsMobileApp.ts';
import { sessionStorage } from './lib/storage/sessionStorage.ts';

// eslint-disable-next-line no-restricted-properties
const { origin, hostname } = window.location ?? {
  hostname: '',
  origin: '',
};

export const ORIGIN = origin;
export const HOSTNAME = hostname;

const mobileApp = sessionStorage.getItem('mobileApp');
setContext('mobileApp', { ...parseMobileApp(mobileApp), mobileApp });

const {
  __CONFIG__: config,
  __TAB_VERSION__: tabVersion,
  __VERSION__: version,
} = getConfig(origin);

export const ENV = config.env;
export const isStaging = ENV === 'staging';
export const isMockprod = ENV === 'mockprod';
export const isProduction = ENV === 'production';
export const devEnv = import.meta.env.DEV && ENV;

export const API_ROOT =
  // Force HTTPS to fix HTTPS enabled storybook in Safari
  import.meta.env.VITE_STORYBOOK === 'true'
    ? `https://${new URL(config.backendHost).host}`
    : config.backendHost;
const API_PATH = '/graphql';
export const API_URL = `${API_ROOT}${API_PATH}`;
export const STRIPE_PUBLIC_KEY = config.stripePublicKey;
export const WALLET_URL = config.walletUrl;
export const ETHERSCAN_URL = isProduction
  ? 'https://etherscan.io'
  : 'https://sepolia.etherscan.io';
export const SOLANA_NET = isProduction ? 'mainnet' : 'devnet';
export const RAMP_API_KEY = config.rampApiKey;
export const RAMP_URL = config.rampUrl;
export const MOONPAY_URL = config.moonpayUrl;
export const LAUNCH_DARKLY_CLIENT_SIDE_ID = config.launchDarklyClientSideID;
export const SEGMENT_API_KEY = config.segmentApiKey;
export const IMPACT_PAGE_LOAD_API_URL = config.impactPageLoadAPIUrl;
export const MANGOPAY_CLIENT_ID = config.mangopayClientId;
export const NETHONE_PROFILER_URL = config.nethoneProviderUrl;
export const GOOGLE_MAPS_API_KEY = config.googleMapsApiKey;
export const ASSETS_HOST = config.assetsHost;

const { sorareRevision } = document.documentElement.dataset;
// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle
export const REVISION = sorareRevision!;

export const IS_PLAYGROUND = import.meta.env.VITE_PLAYGROUND === 'true';
// https://docs.prerender.io/docs/33-overview-of-prerender-crawlers
export const IS_PRERENDER =
  navigator.userAgent.includes(
    'Prerender (+https://github.com/prerender/prerender)'
  ) ||
  //https://gitlab.com/sorare/infra/-/merge_requests/2327
  navigator.userAgent === 'Sorare Headless Chromium';
export const IS_TEST_RUNNER =
  import.meta.env.STORYBOOK === 'true' || import.meta.env.MODE === 'test';

export const VERSION = version;

export const CLIENT_HEADERS: Record<string, string> = {
  'sorare-client': 'Web',
  'sorare-version': VERSION.toString(),
  'sorare-build': REVISION,
  'sorare-tab-version': tabVersion,
};

// The WebSocket API doesn't support custom headers so we put them in the URL
export const WS_ROOT = `${config.wsUrl}/cable?${new URLSearchParams(CLIENT_HEADERS).toString()}`;

export const SHARING_ORIGIN = config.origin || ORIGIN;

export const DEBUG_I18N = sessionStorage.getItem('debugI18n') === 'true';
